import { render, staticRenderFns } from "./priorityForm.vue?vue&type=template&id=35c1b65b&"
import script from "./priorityForm.vue?vue&type=script&lang=js&"
export * from "./priorityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports